/**
 * ToastContainer - Container for rendering multiple toasts
 * Pure React component - no portal logic
 */

import { useEffect } from 'react';
import type { ToastContainerProps } from './types';
import { Toast } from './Toast';
import styles from './Toast.module.css';
import { logger } from '../../utils/logger';

export function ToastContainer({ toasts, onDismiss, className }: ToastContainerProps) {
  useEffect(() => {
    logger.log('[ToastContainer] Rendering with toasts:', toasts.length, toasts);
  }, [toasts]);

  return (
    <div className={`${styles.toastContainer} ${className || ''}`}>
      {toasts.map((toast) => {
        logger.log('[ToastContainer] Rendering toast:', toast.id, toast.title);
        return <Toast key={toast.id} toast={toast} onDismiss={onDismiss} />;
      })}
    </div>
  );
}

